/**
 * @hidden

 */
export var created = 'create';
/**
 * @hidden

 */
export var destroyed = 'destroy';
/**
 * @hidden

 */
export var tableclass = 'tableclass';
/**
 * @hidden

 */
export var load = 'load';
/**
 * Specifies Rich Text Editor internal events
 */
/**
 * @hidden

 */
export var initialLoad = 'initial-load';
/**
 * @hidden

 */
export var contentChanged = 'content-changed';
/**
 * @hidden

 */
export var initialEnd = 'initial-end';
/**
 * @hidden

 */
export var iframeMouseDown = 'iframe-click';
/**
 * @hidden

 */
export var destroy = 'destroy';
/**
 * @hidden

 */
export var toolbarClick = 'toolbarClick';
/**
 * @hidden

 */
export var toolbarRefresh = 'toolbar-refresh';
/**
 * @hidden

 */
export var refreshBegin = 'refresh-begin';
/**
 * @hidden

 */
export var toolbarUpdated = 'toolbar-updated';
/**
 * @hidden

 */
export var bindOnEnd = 'bind-on-end';
/**
 * @hidden

 */
export var htmlToolbarClick = 'html-toolbar-click';
/**
 * @hidden

 */
export var markdownToolbarClick = 'markdown-toolbar-click';
/**
 * @hidden

 */
export var modelChanged = 'model-changed';
/**
 * @hidden

 */
export var tableModulekeyUp = 'tableModulekeyUp';
/**
 * @hidden

 */
export var keyUp = 'keyUp';
/**
 * @hidden

 */
export var keyDown = 'keyDown';
/**
 * @hidden

 */
export var mouseUp = 'mouseUp';
/**
 * @hidden

 */
export var toolbarCreated = 'toolbarCreated';
/**
 * @hidden

 */
export var toolbarRenderComplete = 'toolbarRenderComplete';
/**
 * @hidden

 */
export var enableFullScreen = 'enableFullScreen';
/**
 * @hidden

 */
export var disableFullScreen = 'disableFullScreen';
/**
 * @hidden

 */
export var dropDownSelect = 'dropDownSelect';
/**
 * @hidden

 */
export var beforeDropDownItemRender = 'beforeDropDownItemRender';
/**
 * @hidden

 */
export var execCommandCallBack = 'execCommandCallBack';
/**
 * @hidden

 */
export var imageToolbarAction = 'image-toolbar-action';
/**
 * @hidden

 */
export var audioToolbarAction = 'audio-toolbar-action';
/**
 * @hidden

 */
export var videoToolbarAction = 'video-toolbar-action';
/**
 * @hidden

 */
export var linkToolbarAction = 'link-toolbar-action';
/**
 * @hidden

 */
export var windowResize = 'resize';
/**
 * @hidden

 */
export var resizeStart = 'resizeStart';
/**
 * @hidden

 */
export var onResize = 'resizing';
/**
 * @hidden

 */
export var resizeStop = 'resizeStop';
/**
 * @hidden

 */
export var undo = 'undo';
/**
 * @hidden

 */
export var redo = 'redo';
/**
 * @hidden

 */
export var insertLink = 'insertLink';
/**
 * @hidden

 */
export var unLink = 'unLink';
/**
 * @hidden

 */
export var editLink = 'editLink';
/**
 * @hidden

 */
export var openLink = 'openLink';
/**
 * @hidden

 */
export var actionBegin = 'actionBegin';
/**
 * @hidden

 */
export var actionComplete = 'actionComplete';
/**
 * @hidden

 */
export var updatedToolbarStatus = 'updatedToolbarStatus';
/**
 * @hidden

 */
export var actionSuccess = 'actionSuccess';
/**
 * @hidden

 */
export var updateToolbarItem = 'updateToolbarItem';
/**
 * @hidden

 */
export var insertImage = 'insertImage';
/**
 * @hidden

 */
export var insertAudio = 'insertAudio';
/**
 * @hidden

 */
export var insertVideo = 'insertVideo';
/**
 * @hidden

 */
export var insertCompleted = 'insertCompleted';
/**
 * @hidden

 */
export var imageLeft = 'justifyLeft';
/**
 * @hidden

 */
export var imageRight = 'justifyRight';
/**
 * @hidden

 */
export var imageCenter = 'justifyCenter';
/**
 * @hidden

 */
export var imageBreak = 'break';
/**
 * @hidden

 */
export var imageInline = 'inline';
/**
 * @hidden

 */
export var imageLink = 'insertImgLink';
/**
 * @hidden

 */
export var imageAlt = 'imgAltText';
/**
 * @hidden

 */
export var imageDelete = 'delete';
/**
 * @hidden

 */
export var audioDelete = 'delete';
/**
 * @hidden

 */
export var videoDelete = 'delete';
/**
 * @hidden

 */
export var imageCaption = 'caption';
/**
 * @hidden

 */
export var imageSize = 'imageSize';
/**
 * @hidden

 */
export var videoSize = 'videoSize';
/**
 * @hidden

 */
export var sourceCode = 'sourceCode';
/**
 * @hidden

 */
export var updateSource = 'updateSource';
/**
 * @hidden

 */
export var toolbarOpen = 'toolbarOpen';
/**
 * @hidden

 */
export var beforeDropDownOpen = 'beforeDropDownOpen';
/**
 * @hidden

 */
export var selectionSave = 'selection-save';
/**
 * @hidden

 */
export var selectionRestore = 'selection-restore';
/**
 * @hidden

 */
export var expandPopupClick = 'expandPopupClick';
/**
 * @hidden

 */
export var count = 'count';
/**
 * @hidden

 */
export var contentFocus = 'contentFocus';
/**
 * @hidden

 */
export var contentBlur = 'contentBlur';
/**
 * @hidden

 */
export var mouseDown = 'mouseDown';
/**
 * @hidden

 */
export var sourceCodeMouseDown = 'sourceCodeMouseDown';
/**
 * @hidden

 */
export var editAreaClick = 'editAreaClick';
/**
 * @hidden

 */
export var scroll = 'scroll';
/**
 * @hidden

 */
export var contentscroll = 'contentscroll';
/**
 * @hidden

 */
export var colorPickerChanged = 'colorPickerChanged';
/**
 * @hidden

 */
export var tableColorPickerChanged = 'tableColorPickerChanged';
/**
 * @hidden

 */
export var focusChange = 'focusChange';
/**
 * @hidden

 */
export var selectAll = 'selectAll';
/**
 * @hidden

 */
export var selectRange = 'selectRange';
/**
 * @hidden

 */
export var getSelectedHtml = 'getSelectedHtml';
/**
 * @hidden

 */
export var renderInlineToolbar = 'renderInlineToolbar';
/**
 * @hidden

 */
export var paste = 'paste-content';
/**
 * @hidden

 */
export var imgModule = 'imageModule';
/**
 * @hidden

 */
export var rtlMode = 'rtl-mode';
/**
 * @hidden

 */
export var createTable = 'createTable';
/**
 * @hidden

 */
export var docClick = 'docClick';
/**
 * @hidden

 */
export var tableToolbarAction = 'table-toolbar-action';
/**
 * @hidden

 */
export var checkUndo = 'checkUndoStack';
/**
 * @hidden

 */
export var readOnlyMode = 'readOnlyMode';
/**
 * @hidden

 */
export var moduleDestroy = 'moduleDestroy';
/**
 * @hidden

 */
export var pasteClean = 'pasteClean';
/**
 * @hidden

 */
export var enterHandler = 'enterHandler';
/**
 * @hidden

 */
export var beforeDialogOpen = 'beforeDialogOpen';
/**
 * @hidden

 */
export var clearDialogObj = 'clearDialogObj';
/**
 * @hidden

 */
export var dialogOpen = 'dialogOpen';
/**
 * @hidden

 */
export var beforeDialogClose = 'beforeDialogClose';
/**
 * @hidden

 */
export var dialogClose = 'dialogClose';
/**
 * @hidden

 */
export var beforeQuickToolbarOpen = 'beforeQuickToolbarOpen';
/**
 * @hidden

 */
export var quickToolbarOpen = 'quickToolbarOpen';
/**
 * @hidden

 */
export var quickToolbarClose = 'quickToolbarClose';
/**
 * @hidden

 */
export var popupHide = 'popupHide';
/**
 * @hidden

 */
export var imageSelected = 'imageSelected';
/**
 * @hidden

 */
export var imageUploading = 'imageUploading';
/**
 * @hidden

 */
export var imageUploadSuccess = 'imageUploadSuccess';
/**
 * @hidden

 */
export var imageUploadFailed = 'imageUploadFailed';
/**
 * @hidden

 */
export var imageRemoving = 'imageRemoving';
/**
 * @hidden

 */
export var fileSelected = 'fileSelected';
/**
 * @hidden

 */
export var fileUploading = 'fileUploading';
/**
 * @hidden

 */
export var fileUploadSuccess = 'fileUploadSuccess';
/**
 * @hidden

 */
export var fileUploadFailed = 'fileUploadFailed';
/**
 * @hidden

 */
export var fileRemoving = 'fileRemoving';
/**
 * @hidden

 */
export var afterImageDelete = 'afterImageDelete';
/**
 * @hidden

 */
export var afterMediaDelete = 'afterMediaDelete';
/**
 * @hidden

 */
export var drop = 'drop';
/**
 * @hidden

 */
export var xhtmlValidation = 'xhtmlValidation';
/**
 * @hidden

 */
export var beforeImageUpload = 'beforeImageUpload';
/**
 * @hidden

 */
export var beforeFileUpload = 'beforeFileUpload';
/**
 * @hidden

 */
export var resizeInitialized = 'resizeInitialized';
/**
 * @hidden

 */
export var renderFileManager = 'renderFileManager';
/**
 * @hidden

 */
export var beforeImageDrop = 'beforeImageDrop';
/**
 * @hidden

 */
export var dynamicModule = 'dynamicModule';
/**
 * @hidden

 */
export var beforePasteCleanup = 'beforePasteCleanup';
/**
 * @hidden

 */
export var afterPasteCleanup = 'afterPasteCleanup';
/**
 * @hidden

 */
export var updateTbItemsStatus = 'updateTbItemsStatus';
/**
 * @hidden

 */
export var showLinkDialog = 'showLinkDialog';
/**
 * @hidden

 */
export var closeLinkDialog = 'closeLinkDialog';
/**
 * @hidden

 */
export var showImageDialog = 'showImageDialog';
/**
 * @hidden

 */
export var showAudioDialog = 'showAudioDialog';
/**
 * @hidden

 */
export var showVideoDialog = 'showVideoDialog';
/**
 * @hidden

 */
export var closeImageDialog = 'closeImageDialog';
/**
 * @hidden

 */
export var closeAudioDialog = 'closeAudioDialog';
/**
 * @hidden

 */
export var closeVideoDialog = 'closeVideoDialog';
/**
 * @hidden

 */
export var showTableDialog = 'showTableDialog';
/**
 * @hidden

 */
export var closeTableDialog = 'closeTableDialog';
/**
 * @hidden

 */
export var bindCssClass = 'bindCssClass';
/**
 * @hidden

 */
export var formatPainterClick = 'formatPainterClick';
/**
 * @hidden

 */
export var formatPainterDoubleClick = 'formatPainterDoubleClick';
/**
 * @hidden

 */
export var emojiPicker = 'emojiPicker';
/**
 * @hidden

 */
export var destroyTooltip = 'destroyTooltip';
/**
 * @hidden

 */
export var hidePopup = 'hidePopup';
/**
 * @hidden

 */
export var cleanupResizeElements = 'cleanupResizeElements';
/**
 * @hidden

 */
export var afterKeyDown = 'afterKeyDown';
/**
 * @hidden

 */
export var updateValueOnIdle = 'updateValueOnIdle';
/**
 * @hidden

 */
export var documentClickClosedBy = 'documentClickClosedBy';
/**
 * @hidden

 */
export var showColorPicker = 'showColorPicker';
/**
 * @hidden

 */
export var closeTooltip = 'closeTooltip';
/**
 * @hidden

 */
export var autoResize = 'autoResize';
/**
 * @hidden

 */
export var blockEmptyNodes = "address:empty, article:empty, aside:empty, blockquote:empty,\n details:empty, dd:empty, div:empty, dl:empty, dt:empty, fieldset:empty, footer:empty,form:empty, h1:empty,\n h2:empty, h3:empty, h4:empty, h5:empty, h6:empty, header:empty, hgroup:empty, li:empty, main:empty, nav:empty,\n noscript:empty, output:empty, p:empty, pre:empty, section:empty, td:empty, th:empty";
/**
 * @hidden

 */
export var inlineEmptyNodes = "a:empty, abbr:empty, acronym:empty, b:empty, bdi:empty, bdo:empty, big:empty, button:empty,\ncanvas:empty, cite:empty, code:empty, data:empty, datalist:empty, del:empty, dfn:empty, em:empty, font:empty, i:empty, iframe:empty,\nins:empty, kbd:empty, label:empty, map:empty, mark:empty, meter:empty, noscript:empty, object:empty, output:empty, picture:empty, progress:empty,\nq:empty, ruby:empty, s:empty, samp:empty, script:empty, select:empty, slot:empty, small:empty, span:empty, strong:empty, strike:empty, sub:empty, sup:empty, svg:empty,\ntemplate:empty, textarea:empty, time:empty, u:empty, tt:empty, var:empty, wbr:empty";
/**
 * @hidden

 */
export var supportedUnits = ['px', 'em', 'rem', 'pt', 'cm', 'mm', 'in', 'pc', 'vw', 'vh', 'vmin', 'vmax'];
/**
 * @hidden

 */
export var conversionFactors = {
    'px': {
        'px': 1,
        'em': 0.0625,
        'rem': 0.0625,
        'pt': 0.75,
        'cm': 0.0264583,
        'mm': 0.0026458,
        'in': 0.0104167,
        'pc': 0.0625,
        'vw': 0.00625,
        'vh': 0.00625,
        'vmin': 0.00625,
        'vmax': 0.00625
    },
    'em': {
        'px': 16,
        'em': 1,
        'rem': 1,
        'pt': 12,
        'cm': 0.423333,
        'mm': 0.0423333,
        'in': 0.166667,
        'pc': 0.0625,
        'vw': 1,
        'vh': 1,
        'vmin': 1,
        'vmax': 1
    },
    'rem': {
        'px': 16,
        'em': 1,
        'rem': 1,
        'pt': 12,
        'cm': 0.423333,
        'mm': 0.0423333,
        'in': 0.166667,
        'pc': 0.0625,
        'vw': 1,
        'vh': 1,
        'vmin': 1,
        'vmax': 1
    },
    'pt': {
        'px': 1.33333,
        'em': 0.0833333,
        'rem': 0.0833333,
        'pt': 1,
        'cm': 0.0352778,
        'mm': 0.0035278,
        'in': 0.0138889,
        'pc': 0.0416667,
        'vw': 0.00416667,
        'vh': 0.00416667,
        'vmin': 0.00416667,
        'vmax': 0.00416667
    },
    'cm': {
        'px': 37.7953,
        'em': 2.3622,
        'rem': 2.3622,
        'pt': 28.3465,
        'cm': 1,
        'mm': 0.1,
        'in': 0.393701,
        'pc': 0.148148,
        'vw': 0.0377953,
        'vh': 0.0377953,
        'vmin': 0.0377953,
        'vmax': 0.0377953
    },
    'mm': {
        'px': 3.77953,
        'em': 0.23622,
        'rem': 0.23622,
        'pt': 2.83465,
        'cm': 10,
        'mm': 1,
        'in': 0.0393701,
        'pc': 0.0148148,
        'vw': 0.00377953,
        'vh': 0.00377953,
        'vmin': 0.00377953,
        'vmax': 0.00377953
    },
    'in': {
        'px': 96,
        'em': 6,
        'rem': 6,
        'pt': 72,
        'cm': 2.54,
        'mm': 25.4,
        'in': 1,
        'pc': 0.375,
        'vw': 0.09375,
        'vh': 0.09375,
        'vmin': 0.09375,
        'vmax': 0.09375
    },
    'pc': {
        'px': 16,
        'em': 1,
        'rem': 1,
        'pt': 12,
        'cm': 0.423333,
        'mm': 0.0423333,
        'in': 0.166667,
        'pc': 1,
        'vw': 0.0625,
        'vh': 0.0625,
        'vmin': 0.0625,
        'vmax': 0.0625
    },
    'vw': {
        'px': 160,
        'em': 10,
        'rem': 10,
        'pt': 120,
        'cm': 4.23333,
        'mm': 0.423333,
        'in': 1.66667,
        'pc': 0.625,
        'vw': 1,
        'vh': 1,
        'vmin': 1,
        'vmax': 1
    },
    'vh': {
        'px': 160,
        'em': 10,
        'rem': 10,
        'pt': 120,
        'cm': 4.23333,
        'mm': 0.423333,
        'in': 1.66667,
        'pc': 0.625,
        'vw': 1,
        'vh': 1,
        'vmin': 1,
        'vmax': 1
    },
    'vmin': {
        'px': 160,
        'em': 10,
        'rem': 10,
        'pt': 120,
        'cm': 4.23333,
        'mm': 0.423333,
        'in': 1.66667,
        'pc': 0.625,
        'vw': 1,
        'vh': 1,
        'vmin': 1,
        'vmax': 1
    },
    'vmax': {
        'px': 160,
        'em': 10,
        'rem': 10,
        'pt': 120,
        'cm': 4.23333,
        'mm': 0.423333,
        'in': 1.66667,
        'pc': 0.625,
        'vw': 1,
        'vh': 1,
        'vmin': 1,
        'vmax': 1
    }
};
/**
 * @hidden

 */
export var onHandleFontsizeChange = 'onHandleFontsizeChange';
